import "core-js/modules/es6.string.link";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RangeProduct from '~/components/molecules/Editorial/Global/RangeProduct.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'Range',
  components: {
    GlobalRichText: GlobalRichText,
    RangeProduct: RangeProduct
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  computed: {
    textColor: function textColor() {
      return this.payload.primary.text_color;
    },
    richText: function richText() {
      return this.payload.primary.rich_text || [];
    },
    products: function products() {
      var _this = this;

      return this.payload.items.map(function (item, index) {
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_1440']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
        var product = _this.catalog.products[index];

        if (!product) {
          return null;
        }

        var price = product.price.sales.amount ? product.price.sales.formatted : product.price.base.formatted;
        return {
          withLink: item.link.url,
          link: item.link.url,
          imgSrc: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
          range: item.range,
          product: item.product,
          reference: item.reference,
          button: item.button,
          price: price,
          tracking: {
            data: {
              event_category: item.event_category,
              event_action: item.event_action,
              event_label: item.event_label
            }
          }
        };
      }).filter(Boolean);
    }
  }
};